import React from "react";
import { Drawer, List, ListItemButton, ListItemText, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";

const drawerWidth = 240;

const AdminSidebar = () => {
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: "#000000",
          color: "#fff",
        },
      }}
    >
      <Toolbar />
      <List>
        <ListItemButton component={Link} to="/admin/home/users">
          <ListItemText primary="Users" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/home/requests">
          <ListItemText primary="Requests" />
        </ListItemButton>
        <ListItemButton component={Link} to="/admin/home/movies">
          <ListItemText primary="Movies" />
        </ListItemButton>
      </List>
    </Drawer>
  );
};

export default AdminSidebar;
